import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
@Component({
  selector: 'app-mz-slide',
  templateUrl: './mz-slide.component.html',
  styleUrls: ['./mz-slide.component.scss']
})
export class MzSlideComponent extends GridBaseCase{

  constructor(
    private router:Router,
    private com: CommonService,
  ) { super(); }

  ngOnInit() {
  }
  EventLink(ev: any) {
    let evs = ev.url || '';
    if (evs.trim()) {
      if (evs.indexOf("http") > 0) {
        
      } else {
        localStorage.setItem('element', JSON.stringify(ev));
        this.com.Go(evs);
      }
    }
  }

}
